/* Lightweight module-level ripple bus.
   V4Wrapper registers a handler (connected to useSimState.addRipple) on mount,
   and sets `currentFromAccount` whenever the active persona changes.
   V4AdHocChat's scenario engine just calls `emitRipple(...)` — no prop drilling needed. */

let handler = null;
let currentFromAccount = 'arjun';

export const setRippleHandler = (fn) => {
  handler = fn;
};

export const setRippleFromAccount = (accountId) => {
  currentFromAccount = accountId || 'arjun';
};

export const emitRipple = (to, kind, payload) => {
  if (!handler || !to || !kind || !payload) return;
  try {
    handler(to, kind, payload, currentFromAccount);
  } catch (err) {
    // swallow — ripple shouldn't break scenario playback
    if (typeof console !== 'undefined') console.warn('[rippleBus] emit failed:', err);
  }
};

export const getCurrentFromAccount = () => currentFromAccount;
